import isJSON from "../isJSON/isJSON.util"

export const getParsedJSON = (objectToParse: any): any => {
  return isJSON(objectToParse) ? JSON.parse(objectToParse) : objectToParse
}
